const axios = require('axios')
const config = { apiUrl: process.env.REACT_APP_API_URL }
const authHeader = require('./authHeader')

export const exportService = {
  /**
   * Starts an async export job
   * @param {string} groupId - The group ID to export data for
   * @param {Date|string|null} startDate - Optional start date (ISO 8601 format)
   * @param {Date|string|null} endDate - Optional end date (ISO 8601 format)
   * @returns {Promise<Object>} - Job info with jobId and statusUrl
   */
  startExport: async function (groupId, startDate = null, endDate = null) {
    try {
      const body = {}
      if (startDate) {
        body.startDate = startDate instanceof Date ? startDate.toISOString().split('T')[0] : startDate
      }
      if (endDate) {
        body.endDate = endDate instanceof Date ? endDate.toISOString().split('T')[0] : endDate
      }

      const url = `${config.apiUrl}group/${groupId}/export`

      const response = await axios.post(url, body, {
        headers: authHeader.authHeader()
      })

      return response.data
    } catch (error) {
      console.error('Export service error:', error)
      throw error
    }
  },

  /**
   * Gets the status of an export job
   * @param {string} groupId - The group ID
   * @param {string} jobId - The job ID
   * @returns {Promise<Object>} - Job status with download URL if completed
   */
  getJobStatus: async function (groupId, jobId) {
    try {
      const url = `${config.apiUrl}group/${groupId}/export/${jobId}`

      const response = await axios.get(url, {
        headers: authHeader.authHeader()
      })

      return response.data
    } catch (error) {
      console.error('Get job status error:', error)
      throw error
    }
  },

  /**
   * Gets all export jobs for a group
   * @param {string} groupId - The group ID
   * @param {number} limit - Max number of jobs to return (default 10)
   * @returns {Promise<Array>} - Array of export jobs
   */
  getExportHistory: async function (groupId, limit = 10) {
    try {
      const url = `${config.apiUrl}group/${groupId}/exports?limit=${limit}`

      const response = await axios.get(url, {
        headers: authHeader.authHeader()
      })

      return response.data.exports
    } catch (error) {
      console.error('Get export history error:', error)
      throw error
    }
  },

  /**
   * Downloads a file from a signed URL
   * @param {string} downloadUrl - The signed S3 URL
   * @param {string} filename - The filename to save as
   */
  downloadFromUrl: function (downloadUrl, filename = null) {
    const link = document.createElement('a')
    link.href = downloadUrl
    if (filename) {
      link.download = filename
    }
    link.target = '_blank'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}
